<template>
    <div class="main-container">
        <div class="hdp-uf hdp-uf-dc hdp-w-100">
          <div class="hdp-uf menu-title">
            <p class="psc-color-main psc-font4">{{$t('m.LapModule')}}</p>
          </div>
          <div class="hdp-uf hdp-w-100">
            <p>
              <img class="hdp-w-100" src="../assets/images/bg02.png" alt="">
            </p>
          </div>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            title: {
                firstTitle: '租赁核算模块'
            },
        }
    },
    methods: {

    },
    mounted() {
    }
}
</script>
<style lang="scss" scoped>
/*.index-container {
　　height: 100vh;
    overflow: hidden;
}*/

.main-container{
  .menu-title{
    margin:15px 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Index.vue